import React from 'react';

export const LogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <div title="Správce účtenek s AI" className="cursor-default">
        <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <title>Správce účtenek s AI</title>
            {/* Receipt body */}
            <path
                d="M7 21.23V19C7 16.7909 8.79086 15 11 15H17V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V21.23Z"
                className="stroke-gray-700"
                strokeWidth="1.5"
            />
             {/* Wavy bottom */}
            <path
                d="M7 21.23C7.5 20.23 8.5 19.73 9.5 19.73C10.5 19.73 11.5 20.23 12.5 21.23C13.5 20.23 14.5 19.73 15.5 19.73C16.5 19.73 17.5 20.23 18.5 21.23"
                 className="stroke-gray-700"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* AI Sparkle */}
            <path
                d="M17 9H13M15 7V11"
                className="stroke-blue-500"
                strokeWidth="2"
                strokeLinecap="round"
            />
             <path
                d="M19 4L18.7 5M18.7 5L18 6L17.3 5L18 4L18.7 5Z"
                 className="fill-blue-500 stroke-blue-500"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    </div>
);